import React, { useState } from "react";
import { Button, Checkbox, TextField } from "@mui/material";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { updateDoc, doc as firestoreDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
import SignaturePadComponentV2 from "../Signature/SignaturePadComponentV2";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadString,
} from "firebase/storage";
import ReactDOMServer from "react-dom/server";
import DatePickerComponent from "../DatePickerComponent";
import { StandardDrawerFooter } from "./StandardDrawer";
import "./AdmissionDocumentRedesign.css";

function AddConsentSelfOutingPrivilege(props) {
  const { clientId, closemodal } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState(null);
  const [isSignatureValidated, setIsSignatureValidated] = useState(false);
  const [, setIsSignatureStarted] = useState(false);

  // ...
  const [outingDate, setOutingDate] = useState(null);
  const [timeframe, setTimeframe] = useState("");
  const [goingWith, setGoingWith] = useState("");
  const [destination, setDestination] = useState("");
  const [outingPurpose, setOutingPurpose] = useState("");

  // Contenu formaté avec balises HTML en JSX
  const purposeContent = (
    <div>
      <strong>Purpose:</strong>
      <br />
      This consent form outlines the client's responsibilities when engaging in
      self-outing and the potential consequences of non-compliance. By signing,
      the client acknowledges understanding and agreement to these terms as part
      of their therapeutic process.
    </div>
  );

  const responsibilitiesContent = (
    <div>
      <strong>Responsibilities:</strong>
      <br />
      <u>Adherence to Schedule:</u>
      <br />
      - Return to Miracles Asia main site by the agreed-upon time, no later than
      2:30 p.m.
      <br />
      - Attend all scheduled check-ins during self-outing, if applicable.
      <br />
      <br />
      <u>Behavioural Expectations:</u>
      <br />
      - Maintain sobriety and always abstain from substances, at all times.
      <br />
      - Uphold the Miracles Asia’s standards of conduct and respect community
      norms.
      <br />
      <br />
      <u>Health and Safety:</u>
      <br />
      - Follow all personal safety guidelines provided by staff at Miracles
      Asia.
      <br />
      - Inform the staff at Miracles Asia of any changes in health status or
      emergencies immediately.
      <br />
      <br />
      <u>Communication:</u>
      <br />
      - Maintain regular contact with designated Miracles Asia staff as arranged
      prior to departure.
      <br />- Report back any significant experiences, feelings, or concerns
      encountered during self-outing.
    </div>
  );

  const consequencesContent = (
    <div>
      <strong>Consequences of Non-compliance:</strong>
      <br />
      - Review of Privileges: Removal or suspension of self-outing privileges
      pending a review.
      <br />
      - Additional Treatment Protocols: Possible requirement to participate in
      additional therapeutic interventions or sessions.
      <br />
      - Referral to Treatment Team: Detailed discussion with the treatment team
      to reassess the current treatment plan.
      <br />- Documentation: Incidents of non-compliance will be documented and
      may affect future considerations for self-outing or other privileges
      within the program.
    </div>
  );

  const acknowledgmentContent = (
    <div>
      <strong>Acknowledgment:</strong>
      <br />I acknowledge that I have read and understand the terms and
      conditions of the self-outing privileges as detailed above. I agree to
      adhere to these responsibilities for the benefit of my recovery journey
      and accept the outlined consequences should I fail to meet these
      expectations.
    </div>
  );

  const handleSignatureSave = (dataURL) => {
    setSignatureDataURL(dataURL);
  };

  const handleCheckboxChange = (event) => {
    setChecked1(event.target.checked);
  };

  const uploadSignature = async () => {
    const storage = getStorage();
    const fileName = `${clientId}_selfouting_signature.png`;
    const signatureRef = ref(
      storage,
      `MandatoryForms/ConsentSelfOutingPrivilege/${fileName}`
    );
    await uploadString(signatureRef, signatureDataURL, "data_url");
    const downloadURL = await getDownloadURL(signatureRef);
    return downloadURL;
  };

  const handleFormSubmit = async () => {
    if (!checked1 || !signatureDataURL || !isSignatureValidated) {
      showCustomToast(
        "Please agree to all the terms before submitting.",
        "error"
      );
      return;
    }
    try {
      setIsLoading(true);
      const signatureURL = await uploadSignature();

      await addDoc(
        collection(db, "clients", clientId, "ConsentSelfOutingPrivileges"),
        {
          checked1,
          purpose: ReactDOMServer.renderToStaticMarkup(purposeContent),
          responsibilities: ReactDOMServer.renderToStaticMarkup(
            responsibilitiesContent
          ),
          consequences:
            ReactDOMServer.renderToStaticMarkup(consequencesContent),
          acknowledgment: ReactDOMServer.renderToStaticMarkup(
            acknowledgmentContent
          ),
          signatureURL,
          signedOn: serverTimestamp(),
          outingDate,
          timeframe,
          goingWith,
          destination,
          outingPurpose,
          createdAt: serverTimestamp(),
        }
      );

      // Mise à jour du document client dans "clients"
      const clientDocRef = firestoreDoc(db, "clients", clientId);
      await updateDoc(clientDocRef, {
        ConsentSelfOutingPrivilegeOk: true,
        ConsentSelfOutingPrivilegeDateSigned: serverTimestamp(),
      });
      showCustomToast(
        "Consent and Self-Outing Privilege form successfully submitted!",
        "success"
      );
      setIsLoading(false);
      closemodal();
    } catch (error) {
      console.error("Error submitting form:", error);
      showCustomToast("Error submitting form", "error");
      setIsLoading(false);
    }
  };

  const clientDisplayName =
    [props.firstName, props.lastName].filter(Boolean).join(" ") ||
    props.clientName ||
    "Client";

  return (
    <>
      <div className="admission-document-shell admission-card-form-shell consent-agreement-form-shell">
        <TopTitleFormComponent
          title="Consent and Self-Outing Privilege Form"
          eyebrow="ADMISSION FORM"
          subtitle={clientDisplayName}
          closemodal={closemodal}
        />

        <div className="admission-document-body consent-agreement-form-body">
          <div className="text-block" style={{ whiteSpace: "normal" }}>
            {purposeContent}
          </div>
          <div
            className="text-block"
            style={{ whiteSpace: "normal", marginTop: "10px" }}
          >
            {responsibilitiesContent}
          </div>
          <div
            className="text-block"
            style={{ whiteSpace: "normal", marginTop: "10px" }}
          >
            {consequencesContent}
          </div>
          <div
            className="text-block"
            style={{ whiteSpace: "normal", marginTop: "20px" }}
          >
            {acknowledgmentContent}
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            <div style={{ marginTop: "10px", width: "30%" }}>
              <DatePickerComponent
                title="Date of Outing"
                value={outingDate}
                onChange={setOutingDate}
              />
            </div>
            <div
              style={{ marginTop: "10px", width: "30%", paddingTop: "28px" }}
            >
              <TextField
                label="Timeframe"
                value={timeframe}
                onChange={(e) => setTimeframe(e.target.value)}
                fullWidth
              />
            </div>
            <div
              style={{ marginTop: "10px", width: "30%", paddingTop: "28px" }}
            >
              <TextField
                label="Who they are going with"
                value={goingWith}
                onChange={(e) => setGoingWith(e.target.value)}
                fullWidth
              />
            </div>
            <div
              style={{ marginTop: "10px", width: "30%", paddingTop: "28px" }}
            >
              <TextField
                label="Destination"
                value={destination}
                onChange={(e) => setDestination(e.target.value)}
                fullWidth
              />
            </div>
            <div
              style={{ marginTop: "10px", width: "30%", paddingTop: "28px" }}
            >
              <TextField
                label="Purpose (e.g., shopping, salon, personal errand)"
                value={outingPurpose}
                onChange={(e) => setOutingPurpose(e.target.value)}
                fullWidth
              />
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            <Checkbox checked={checked1} onChange={handleCheckboxChange} />I
            fully understand and agree to the above terms.
          </div>
          <div
            style={{ width: "100%", marginBottom: "25px", marginTop: "20px" }}
          >
            <SignaturePadComponentV2
              onSignatureSave={handleSignatureSave}
              signatureDataURL={signatureDataURL}
              onSignatureStart={() => setIsSignatureStarted(true)}
              onSignatureValidate={setIsSignatureValidated}
            />
          </div>
        </div>
        <StandardDrawerFooter className="admission-document-footer">
          <div>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={closemodal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleFormSubmit}
              style={
                isLoading
                  ? {
                      backgroundColor: "red",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : !signatureDataURL || !isSignatureValidated || !checked1
                  ? {
                      backgroundColor: "grey",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : {
                      backgroundColor: "#1565C0",
                      color: "white",
                      marginLeft: "15px",
                    }
              }
              disabled={
                isLoading ||
                !signatureDataURL ||
                !isSignatureValidated ||
                !checked1
              }
            >
              {isLoading ? "SAVING..." : "SAVE"}
            </Button>
          </div>
        </StandardDrawerFooter>
      </div>
    </>
  );
}

export default AddConsentSelfOutingPrivilege;
